import { Link, useLocation, useParams } from "react-router-dom";
import { isObjectEmpty } from "../utilities/helperFunctions";
import textData from "../textData.json";
import { useContext } from "react";
import { LangContext, LangContextType } from "../utilities/customHooks";

type Route = {
  path: string,
  text: string,
}

function Breadcrumb (
  { 
    breadcrumbRoutes 
  }
  :
  {
    breadcrumbRoutes: Route[]
  }
) {
  const { langState } = useContext(LangContext) as LangContextType
  const { pathname } = useLocation();
  const params = useParams();

  const getBreadcrumbName = (path: string, params: Record<string, string | undefined>) => {
    let pathWithParamProp = path;
    if (!isObjectEmpty(params)) {
      // Replace actual values with path parameters
      for (const key in params) {
        const value = params[key];
        if (value !== undefined) {
          pathWithParamProp = path.replace(value, `:${key}`);
        }
      }
    }

    const matchedRoute = breadcrumbRoutes.find((route) =>
      route.path === pathWithParamProp
    );

    return matchedRoute?.text || "";
  };

  return (
    <nav className="text-sm font-medium text-text/70">
      <ol className="list-none p-0 flex">
        {
          // create an array of paths that doesn't include the initial /, then map through each path
          pathname.split('/').filter(path => path)
            .map((_path, index, pathsArray) => ({
              routePath: `/${pathsArray.slice(0, index + 1).join('/')}`,
              breadcrumbName: getBreadcrumbName(`/${pathsArray.slice(0, index + 1).join('/')}`, params),
            }))
            .filter(({ breadcrumbName }) => breadcrumbName !== "")
            .map(({ routePath, breadcrumbName }, index, filtered) => {
            const isLastVisible = index === filtered.length - 1;

            return (
              <li
                key={routePath}
                className={`flex items-center ${isLastVisible ? "text-text" : "text-text/70 hover:underline hover:text-text/80" }`}
              >
                {!isLastVisible ? (
                  <Link to={routePath}>{breadcrumbName}</Link>
                ) : (
                  <span>{breadcrumbName}</span>
                )}
                {!isLastVisible && <span className="mx-2">/</span>}
              </li>
            );
          })
        }
      </ol>
    </nav>
  );
};

export default Breadcrumb;
